<template>
  <div>
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        <IconMoreOptionComponent size="small" theme="blue" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <!-- 1. Firmar / Re-intentar firma (siempre primero cuando aplica) -->
        <template
          v-if="
            status === 'draft' || status === 'failed' || status === 'timeout'
          "
        >
          <el-dropdown-item command="invoice-signature">
            <i class="el-icon-edit-outline"></i>
            {{ status === "timeout" ? "Re-intentar firma" : "Firmar" }}
          </el-dropdown-item>
        </template>

        <!-- Ver documento -->
        <el-dropdown-item command="invoice-view-doc">
          <i class="el-icon-view"></i> Ver documento
        </el-dropdown-item>

        <!-- Agregar pago -->
        <el-dropdown-item
          v-if="status !== 'nuled' && !is_paid"
          command="invoice-add-payment"
        >
          <i class="el-icon-wallet"></i> Agregar pago
        </el-dropdown-item>

        <!-- Editar pagos (cuando ya hay pagos registrados) -->
        <el-dropdown-item
          v-if="
            status !== 'nuled' &&
              (is_paid || (invoice && invoice.payment_status === 'partial'))
          "
          command="invoice-edit-payments"
        >
          <i class="el-icon-edit-outline"></i> Editar pagos
        </el-dropdown-item>

        <!-- Enviar documento -->
        <el-dropdown-item v-if="status !== 'nuled'" command="invoice-send">
          <i class="el-icon-s-promotion"></i> Enviar documento
        </el-dropdown-item>

        <!-- Link de pago (solo si la factura está aprobada y no pagada) -->
        <el-dropdown-item
          v-if="status === 'success' && !is_paid"
          command="invoice-paylink"
        >
          <i class="el-icon-link"></i> Link de pago
        </el-dropdown-item>

        <!-- Descargar PDF -->
        <el-dropdown-item command="invoice-download">
          <i class="el-icon-download"></i> Descargar PDF
        </el-dropdown-item>

        <!-- Vista de impresión -->
        <el-dropdown-item command="invoice-print">
          <i class="el-icon-printer"></i> Vista de impresión
        </el-dropdown-item>

        <!-- Editar -->
        <template v-if="status === 'draft' || status === 'failed'">
          <el-dropdown-item command="invoice-edit">
            <i class="el-icon-edit"></i> Editar
          </el-dropdown-item>
        </template>

        <!-- Reactivar -->
        <el-dropdown-item
          v-if="status === 'nuled'"
          command="invoice-reactivate"
        >
          <i class="el-icon-refresh-right"></i> Reactivar factura
        </el-dropdown-item>

        <!-- Anular -->
        <template v-if="status === 'success'">
          <el-tooltip
            v-if="isConsumidorFinal"
            content="Las facturas a consumidor final no pueden anularse conforme a la Resolución SRI NAC-017 (2026)."
            placement="left"
            effect="dark"
          >
            <span
              class="el-dropdown-menu__item is-disabled nuled-disabled-item"
            >
              <i class="el-icon-circle-close"></i> Anular factura
            </span>
          </el-tooltip>
          <el-dropdown-item v-else command="invoice-nuled">
            <i class="el-icon-circle-close"></i> Anular factura
          </el-dropdown-item>
        </template>

        <!-- Eliminar (siempre al final) -->
        <template
          v-if="
            status === 'draft' || status === 'failed' || status === 'timeout'
          "
        >
          <el-dropdown-item command="invoice-delete" divided>
            <i class="el-icon-delete"></i> Eliminar
          </el-dropdown-item>
        </template>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog
      :visible.sync="invoicePrint"
      append-to-body
      custom-class="fullscreen-content-modal"
    >
      <div class="d-flex justify-content-center">
        <print-invoice :invoice="invoice" id="printInvoice" />
      </div>
      <div class="d-flex justify-content-center align-items-center mt-5">
        <button type="button" class="btn md__btn-primary mr-4" @click="print">
          Imprimir
        </button>
      </div>
    </el-dialog>

    <SigningConfirmModal
      :visible.sync="invoiceSRIOuterVisible"
      :documentNumber="invoice ? invoice.number_invoice : ''"
      :clientName="invoice && invoice.client ? invoice.client.name : ''"
      :amount="invoice ? invoice.total : 0"
      @confirm="sendInvoiceSRI"
    />

    <el-dialog
      title=""
      :visible.sync="invoiceNuledOuterVisible"
      append-to-body
      custom-class="confirm-modal"
    >
      <div class="wrapper__invoice-nuled text-center">
        <img :src="icoNotifyDanger" alt="ico danger" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Anular esta factura?
        </h4>

        <p
          class="text-color-primary mt-3"
          style="font-size: 14px; line-height: 1.6;"
        >
          Para completar la anulación debes ingresar al portal del SRI (<LinkSRI />)
          y anular el comprobante
          <strong>antes del día 7 del mes siguiente</strong>
          a la fecha de emisión.
        </p>
        <p class="text-color-primary" style="font-size: 13px; color: #6b7280;">
          Si el receptor debe aceptar, tiene
          <strong>5 días hábiles</strong> para hacerlo. Mydessk marcará esta
          factura como anulada en tu registro interno.
        </p>

        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="toggleModalInvoiceNuled"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent
            title="Anular"
            @onSaveClick="onInvoiceNuled"
          />
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="invoiceDeleteOuterVisible"
      append-to-body
      custom-class="confirm-modal"
    >
      <div class="wrapper__invoice-delete text-center">
        <img :src="icoNotifyDanger" alt="ico danger" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Seguro desea eliminar la factura?
        </h4>

        <p class="text-color-primary text-break">
          Recuerde que solo puede eliminar las facturas en borrador.
        </p>

        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="toggleModalInvoiceDelete"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent
            title="Eliminar"
            @onSaveClick="onInvoiceDelete"
          />
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="invoiceReactivateVisible"
      append-to-body
      custom-class="confirm-modal"
    >
      <div class="text-center">
        <i
          class="el-icon-refresh-right"
          style="font-size:30px;color:#3ecfb4;"
        ></i>
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Reactivar esta factura?
        </h4>
        <p class="text-color-primary">
          La factura volverá al estado <strong>Aprobada</strong> y podrá ser
          utilizada normalmente.
        </p>
        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="invoiceReactivateVisible = false"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent
            title="Reactivar"
            @onSaveClick="onInvoiceReactivate"
          />
        </div>
      </div>
    </el-dialog>

    <Preview
      :invoice="invoice"
      :showModal="invoicePreview"
      :status="status"
      @close="invoicePreview = false"
      @action="handlePreviewAction"
    />

    <WrapperSendDocumentDrawer
      @onDocumentSend="onDocumentSend"
      @onCloseDrawer="onCloseDocumentSendDrawer"
      :visibleDocumentSend="visibleDocumentSend"
      :isLoadingConfigTexts="false"
      :toMails="toMails"
      :toPhone="toPhone"
      :clientId="invoice && invoice.client ? invoice.client.id : null"
      :recipientName="invoice && invoice.client ? invoice.client.name : ''"
      :messageableType="'invoice'"
      :messageableId="id"
      :moduleType="'invoice'"
      :defaultMessage="invoiceDefaultMessage"
      :draftKey="'draft-invoice-' + id"
    />
  </div>
</template>
<style lang="scss" scoped>
.img-sm {
  width: 0.8rem !important;
}
.nuled-disabled-item {
  display: block;
  padding: 0 20px;
  line-height: 36px;
  font-size: 14px;
  color: #c0c4cc;
  cursor: not-allowed;
  white-space: nowrap;

  i {
    margin-right: 5px;
  }
}
</style>
<script>
import WrapperSendDocumentDrawer from "../../../../components/WrapperSendDocumentDrawer";
import invoiceService from "../services/invoiceService";
import { signInvoiceSRI } from "../services/signInvoiceSRI";
import PrintInvoice from "./PrintInvoice.vue";
import IconMoreOptionComponent from "@/components/General/IconMoreOption";
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import Preview from "./InvoicePreview.vue";
import LinkSRI from "@/components/General/LinkSRI";
import SigningConfirmModal from "@/components/General/SigningConfirmModal";
import { signingEventBus } from "@/services/signingEventBus";

import {
  icoNotifyDanger,
  iconEdit,
  iconDelete,
  iconNuled,
  iconSend,
  iconHistory,
  iconDownload,
  iconCheck,
  icoSignature,
  icoPreview,
  icoPaylinkNew,
  icoPrint,
  icoWallet
} from "@/services/resources";
import { downloadFile } from "@/assets/utils/files";

export default {
  name: "InvoiceOptionsByStatus",
  data() {
    return {
      icoNotifyDanger,
      iconEdit,
      iconDelete,
      iconNuled,
      iconSend,
      iconHistory,
      iconDownload,
      iconCheck,
      icoSignature,
      icoPreview,
      icoPaylinkNew,
      icoPrint,
      icoWallet,
      invoiceSRIOuterVisible: false,
      invoiceNuledOuterVisible: false,
      invoiceDeleteOuterVisible: false,
      invoiceReactivateVisible: false,
      visibleDocumentSend: false,
      visibleDocumentHistoryEmail: false,
      invoice: null,
      invoicePrint: false,
      invoicePreview: false,
      toMails: [],
      toPhone: ""
    };
  },
  props: ["status", "id", "is_paid", "emission_date", "client_document"],
  computed: {
    textOptionIsPaid() {
      return this.is_paid ? "Desmarcar" : "Marcar";
    },
    isConsumidorFinal() {
      return this.client_document === "9999999999999";
    },
    invoiceDefaultMessage() {
      if (!this.invoice) return "";
      const name = this.invoice.client?.name || "";
      const number = this.invoice.number_invoice || "";
      return `Hola ${name},\n\nSe ha emitido una factura electrónica bajo el Nº- ${number}.\n\nAdjunto encontrarás el PDF y XML de tu factura.\n\nCualquier consulta, con gusto te atiendo.`;
    }
  },
  methods: {
    print() {
      const prtHtml = document.getElementById("printInvoice").innerHTML;
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <style>
                  body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";}
                  .d-flex { display: -ms-flexbox !important; display: -webkit-box !important; display: flex !important;}
                  .justify-content-center { -ms-flex-pack: center !important;  -webkit-box-pack: center !important; justify-content: center !important;}
                  .justify-content-between {  -ms-flex-pack: justify !important; -webkit-box-pack: justify !important; justify-content: space-between !important;}
                  .mt-4, .my-4 { margin-top: 1.5rem !important; }
                  .m-0 { margin: 0 !important; }
                  .m-2 { margin: 0.5rem !important; }
                  .mt-2, .my-2 { margin-top: 0.5rem !important; }
                  .font-semi-bold { font-weight: 600; }
                  h1, h2, h3, h4, h5, h6 { margin-top: 0; margin-bottom: 0.5rem; }
                  .font-bold { font-weight: 700; }
                  p { margin: 0; }
                  .text-pre-wrap { white-space: pre-wrap; word-wrap: break-word; }
                  .access_key { font-size: 12px !important; }
            </style>
          </head>
          <body>
            <div id="dataPrint">
              ${prtHtml}
            </div>
          </body>
        </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },

    toogleModalInvoiceSRI() {
      this.invoiceSRIOuterVisible = true;
    },

    async sendInvoiceSRI() {
      const invoiceId = this.invoice.id;
      const clientName = this.invoice.client ? this.invoice.client.name : "";
      const documentNumber = this.invoice.number_invoice || "";

      this.invoiceSRIOuterVisible = false;

      // Emit signing start for toast + card state
      signingEventBus.$emit("signing:start", {
        id: invoiceId,
        clientName,
        documentNumber
      });
      this.$emit("onSigningStart", invoiceId);

      try {
        const { success, message, data } = await signInvoiceSRI(invoiceId);

        if (success) {
          signingEventBus.$emit("signing:done", {
            id: invoiceId,
            clientName,
            documentNumber
          });
          this.invoice = data;
          this.$emit("onSigningDone", { id: invoiceId, data });
        } else {
          signingEventBus.$emit("signing:error", {
            id: invoiceId,
            message: message || "Error al firmar"
          });
          this.$emit("onSigningError", invoiceId);
        }
      } catch (error) {
        signingEventBus.$emit("signing:error", {
          id: invoiceId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al firmar"
        });
        this.$emit("onSigningError", invoiceId);
      }
    },
    async getInvoice(invoiceId) {
      try {
        let response = await invoiceService
          .getInvoceId(invoiceId)
          .finally(() => {});
        if (response) {
          this.invoice = response.data.data;
        }
      } catch (error) {
        return false;
      }
    },
    async onInvoiceNuled() {
      try {
        this.$store.dispatch("toggleRequestLoading");
        const { id: invoiceId } = this.invoice;
        let response = await invoiceService
          .updateInvoiceStatus({
            user_business_invoice_id: invoiceId
          })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
            this.toggleModalInvoiceNuled();
          });
        const { success, data, message } = response.data;
        if (success) {
          this.invoice = data;
          this.$notifications.success({
            message
          });
          this.$emit("onSigningDone", { id: invoiceId, data });
        }
      } catch (error) {
        return false;
      }
    },
    async onInvoiceReactivate() {
      try {
        this.$store.dispatch("toggleRequestLoading");
        const { id: invoiceId } = this.invoice;
        let response = await invoiceService
          .reactivateInvoice(invoiceId)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
            this.invoiceReactivateVisible = false;
          });
        const { success, data, message } = response.data;
        if (success) {
          this.invoice = data;
          this.$notifications.success({
            message: message || "Factura reactivada exitosamente"
          });
          this.$emit("onSigningDone", { id: invoiceId, data });
        }
      } catch (error) {
        return false;
      }
    },
    async onInvoiceDelete() {
      try {
        const { id: invoiceId } = this.invoice;
        let response = await invoiceService
          .deleteInvoceId(invoiceId)
          .finally(() => {
            this.toggleModalInvoiceDelete();
          });
        const { success, message, quote_new_status, quote_id } = response.data;
        if (success) {
          this.$notifications.success({
            message
          });
          this.$emit("onDocDeleted", invoiceId);
          // Notify quote column to update the linked quote with the real new status
          if (quote_id && quote_new_status) {
            signingEventBus.$emit("quote:status-changed", {
              quoteId: quote_id,
              status: quote_new_status
            });
          }
        }
      } catch (error) {
        return false;
      }
    },

    handlePreviewAction(command) {
      const closeFirst = ["invoice-view-doc", "invoice-edit", "invoice-print"];
      if (closeFirst.includes(command)) {
        this.invoicePreview = false;
      }
      if (command === "invoice-send") {
        this.dimPreview(true);
      }
      this.$nextTick(() => {
        this.handleCommand(command);
      });
    },
    dimPreview(dim) {
      const el = document.querySelector(".ipf-fullscreen");
      if (el) el.style.zIndex = dim ? "1" : "2100";
    },
    async handleCommand(command) {
      if (this.invoice === null) {
        await this.getInvoice(this.id);
        // Wait for Vue to finish re-rendering after data load
        await this.$nextTick();
      }

      switch (command) {
        case "invoice-nuled":
          this.toggleModalInvoiceNuled();
          break;
        case "invoice-preview":
          this.invoicePreview = true;
          break;
        case "invoice-view-doc":
          this.$emit("goPage", "sales.invoices.view", { id: this.id });
          break;
        case "invoice-signature":
          this.toogleModalInvoiceSRI();
          break;
        case "invoice-paylink":
          this.$emit("payLink");
          break;
        case "invoice-edit":
          this.$emit("goPage", "sales.invoices.edit", {
            id: this.id
          });
          break;
        case "invoice-send":
          this.onOpenDocumentSendDrawer();
          break;
        case "invoice-history-email":
          this.visibleDocumentHistoryEmail = true;
          break;
        case "invoice-delete":
          this.toggleModalInvoiceDelete();
          break;
        case "invoice-download":
          this.invoiceDownload();
          break;
        case "invoice-paid":
          this.invoicePaid();
          break;
        case "invoice-print":
          this.invoicePrint = true;
          break;
        case "invoice-reactivate":
          this.invoiceReactivateVisible = true;
          break;
        case "invoice-add-payment":
          this.$root.$emit("open-payment-modal", this.invoice);
          break;
        case "invoice-edit-payments":
          this.$root.$emit("open-payment-modal", {
            invoice: this.invoice,
            tab: "partial"
          });
          break;
      }
    },

    async invoicePaid() {
      try {
        const { is_paid, id: invoiceId } = this.invoice;
        let response = await invoiceService
          .invoicePaid({
            user_business_invoice_id: invoiceId,
            is_paid: !is_paid
          })
          .finally(() => {});
        const { success, message, data } = response.data;
        if (success) {
          this.invoice = data;
          this.$notifications.success({
            message
          });
          this.$emit("onSigningDone", { id: invoiceId, data });
        }
      } catch (error) {
        return false;
      }
    },
    async invoiceDownload() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const { number_invoice, id } = this.invoice;
        let response = await invoiceService
          .invoiceDownload({
            id
          })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        const { data } = response;
        if (data) {
          downloadFile(data, `Factura - #${number_invoice}`);
        }
      } catch (error) {
        return false;
      }
    },
    async sendInvoiceEmail({ data }) {
      const emailId = `email-invoice-${Date.now()}`;
      const clientName = this.invoice?.client?.name || "";
      const docNumber = this.invoice?.number_invoice || "";

      this.visibleDocumentSend = false;
      this.dimPreview(false);

      signingEventBus.$emit("email:start", {
        id: emailId,
        clientName,
        documentNumber: `Factura #${docNumber}`
      });

      try {
        let response = await invoiceService.sendInvoiceEmail({ data });
        const { success, message } = response.data;
        if (success) {
          signingEventBus.$emit("email:done", {
            id: emailId,
            clientName,
            documentNumber: `Factura #${docNumber}`
          });
        } else {
          signingEventBus.$emit("email:error", {
            id: emailId,
            message: message || "Error al enviar el documento"
          });
        }
      } catch (error) {
        signingEventBus.$emit("email:error", {
          id: emailId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al enviar"
        });
      }
    },
    toggleModalInvoiceNuled() {
      this.invoiceNuledOuterVisible = !this.invoiceNuledOuterVisible;
    },
    toggleModalInvoiceDelete() {
      this.invoiceDeleteOuterVisible = !this.invoiceDeleteOuterVisible;
    },
    async onOpenDocumentSendDrawer() {
      const { client } = this.invoice;
      if (client && client.email) {
        this.toMails = [client.email];
      }
      this.toPhone = client && client.phone ? String(client.phone).trim() : "";
      this.visibleDocumentSend = true;
    },
    onCloseDocumentSendDrawer() {
      this.visibleDocumentSend = false;
      this.dimPreview(false);
    },
    onCloseDocumentSendEmailHistory() {
      this.visibleDocumentHistoryEmail = false;
    },
    onDocumentSend({ data }) {
      data.append("invoice_id", this.invoice.id);

      this.sendInvoiceEmail({ data });
    }
  },
  components: {
    IconMoreOptionComponent,
    ButtonPrimaryComponent,
    WrapperSendDocumentDrawer,
    PrintInvoice,
    Preview,
    LinkSRI,
    SigningConfirmModal
  }
};
</script>
